import { useState } from 'react';
import { MultiFactorAuthForm } from './MultiFactorAuthForm';
import { LoginWithEmailForm } from './LoginWithEmailForm';

type Props = {
  onClose(): void;
};

export const LoginWithEmailFormContainer: React.FC<Props> = ({ onClose }: Props) => {
  const [temporaryId, setTemporaryId] = useState('');

  return (
    <>
      {temporaryId ? (
        <MultiFactorAuthForm temporaryId={temporaryId} setTemporaryId={setTemporaryId} />
      ) : (
        <LoginWithEmailForm setTemporaryId={setTemporaryId} onClose={onClose} />
      )}
    </>
  );
};
